// extracted by mini-css-extract-plugin
export default {"container":"SharingWidget__container___UnD9v","icon":"SharingWidget__icon___Rek8d","shareText":"SharingWidget__shareText___drf9X"};